import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { BreadcrumbService } from 'app/shared/services/breadcrumb/breadcrumb.service';
import { TemplateService } from '../../services/template/template.service';
import { map } from 'rxjs/operators';

export const templateResolver: ResolveFn<any> = (
    route: ActivatedRouteSnapshot
): Observable<any> => {
    const templateService = inject(TemplateService);
    const _breadcrumbService = inject(BreadcrumbService);
    const id = route.paramMap.get('sport');

    if (!id) {
        return of(null);
    }

    return templateService.getSports().pipe(
        map((sports) => {
            const sport = sports.find((x) => x.id === id);
            if (sport) {
                const title = sport.name;
                _breadcrumbService.updateBreadcrumbs([
                    { label: 'settings.template-editor.title', link: '/settings/template/editor' },
                    { label: title },
                ]);
            }
            return null;
        })
    );
};
